import { ReactNode } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Icon } from '../../../../core/components/atoms/Icon';

interface ISectionContainer {
  children: ReactNode;
  title: string;
  warning?: string | null;
}

export function SectionContainer({
  children,
  title,
  warning,
}: ISectionContainer) {
  return (
    <div className='bg-mono-color-white flex flex-col gap-xxl rounded-md p-6 shadow-level-1'>
      <Typography size='h4' type='titleSection'>
        {title}
      </Typography>
      {children}
      {warning && (
        <div className='flex flex-row items-center gap-xs'>
          <Icon
            Icon='info'
            type='material'
            className='text-mono-color-darkest text-md'
          />
          <Typography size='small'>{warning}</Typography>
        </div>
      )}
    </div>
  );
}
